import { ThemeTokens } from './theme.model';

// ─────────────────────────────────────────────────────────────────────────────
// 🌌  COSMOS — oscuro navy / indigo  (tema actual)
// ─────────────────────────────────────────────────────────────────────────────
export const THEME_COSMOS: ThemeTokens = {
  id:   'cosmos',
  name: 'Cosmos',
  dark: true,

  pageBg:   '#0f1229',
  cardBg:   '#151938',
  cardBg2:  '#1e2456',
  cardBg3:  '#252b6c',
  cardBorder:  'rgba(255,255,255,0.08)',
  cardShadow:  '0 8px 32px rgba(0,0,0,0.35), 0 0 0 1px rgba(99,102,241,0.15)',

  textPrimary:   '#ffffff',
  textSecondary: 'rgba(255,255,255,0.75)',
  textMuted:     'rgba(255,255,255,0.4)',

  accent:     '#6366f1',
  accentGlow: '#6366f199',
  accentSoft: 'rgba(99,102,241,0.15)',

  success: '#4ade80',
  warning: '#fb923c',
  danger:  '#f87171',

  divider: 'rgba(255,255,255,0.08)',

  chartGrid:        'rgba(255,255,255,0.06)',
  chartAxis:        'rgba(255,255,255,0.45)',
  chartTooltipBg:   '#1e2456',
  chartTooltipText: '#ffffff',

  palette: [
    '#6366f1',  // indigo
    '#38bdf8',  // sky
    '#34d399',  // emerald
    '#fb923c',  // orange
    '#f472b6',  // pink
    '#a78bfa',  // violet
    '#facc15',  // yellow
    '#2dd4bf',  // teal
  ],
};

// ─────────────────────────────────────────────────────────────────────────────
// 🌤️  SLATE — claro profesional, gris-blanco
// ─────────────────────────────────────────────────────────────────────────────
export const THEME_SLATE: ThemeTokens = {
  id:   'slate',
  name: 'Slate',
  dark: false,

  pageBg:   '#f1f5f9',
  cardBg:   '#ffffff',
  cardBg2:  '#f8fafc',
  cardBg3:  '#f1f5f9',
  cardBorder:  'rgba(15,23,42,0.08)',
  cardShadow:  '0 4px 24px rgba(15,23,42,0.08), 0 0 0 1px rgba(15,23,42,0.05)',

  textPrimary:   '#0f172a',
  textSecondary: '#334155',
  textMuted:     '#94a3b8',

  accent:     '#6366f1',
  accentGlow: '#6366f133',
  accentSoft: 'rgba(99,102,241,0.08)',

  success: '#16a34a',
  warning: '#d97706',
  danger:  '#dc2626',

  divider: 'rgba(15,23,42,0.08)',

  chartGrid:        'rgba(15,23,42,0.06)',
  chartAxis:        '#64748b',
  chartTooltipBg:   '#1e293b',
  chartTooltipText: '#f8fafc',

  palette: [
    '#6366f1',  // indigo
    '#0ea5e9',  // sky
    '#10b981',  // emerald
    '#f59e0b',  // amber
    '#ec4899',  // pink
    '#8b5cf6',  // violet
    '#eab308',  // yellow
    '#14b8a6',  // teal
  ],
};

// ─────────────────────────────────────────────────────────────────────────────
// 🌅  EMBER — oscuro cálido, ámbar / coral
// ─────────────────────────────────────────────────────────────────────────────
export const THEME_EMBER: ThemeTokens = {
  id:   'ember',
  name: 'Ember',
  dark: true,

  pageBg:   '#1a1208',
  cardBg:   '#1f1610',
  cardBg2:  '#2a1d0f',
  cardBg3:  '#33240f',
  cardBorder:  'rgba(251,191,36,0.12)',
  cardShadow:  '0 8px 32px rgba(0,0,0,0.4), 0 0 0 1px rgba(251,146,60,0.15)',

  textPrimary:   '#fef3c7',
  textSecondary: 'rgba(254,243,199,0.8)',
  textMuted:     'rgba(254,243,199,0.4)',

  accent:     '#f59e0b',
  accentGlow: '#f59e0b99',
  accentSoft: 'rgba(245,158,11,0.15)',

  success: '#4ade80',
  warning: '#fb923c',
  danger:  '#f87171',

  divider: 'rgba(251,191,36,0.1)',

  chartGrid:        'rgba(254,243,199,0.06)',
  chartAxis:        'rgba(254,243,199,0.5)',
  chartTooltipBg:   '#2a1d0f',
  chartTooltipText: '#fef3c7',

  palette: [
    '#f59e0b',  // amber
    '#fb923c',  // orange
    '#f472b6',  // pink
    '#34d399',  // emerald
    '#38bdf8',  // sky
    '#a78bfa',  // violet
    '#fbbf24',  // yellow
    '#2dd4bf',  // teal
  ],
};

// ─────────────────────────────────────────────────────────────────────────────
export const ALL_THEMES: ThemeTokens[] = [THEME_COSMOS, THEME_SLATE, THEME_EMBER];
export const DEFAULT_THEME = THEME_SLATE;
